import React, { useState } from 'react';
import { supabase } from './supabaseClient';
import { t, getLang, setLang } from './i18n';

// Supabase n-are termen propriu de asteptare: daca serverul tace, cererea atarna
// la nesfarsit si omul ramane cu butonul invartindu-se, fara niciun mesaj. Asa a
// aratat pana Supabase din 19 septembrie 2026.
const ASTEPTARE_MAX = 15000;

function cuTermen(promisiune) {
  let ceas;
  const termen = new Promise(resolve => {
    ceas = setTimeout(() => resolve({ error: { expirat: true } }), ASTEPTARE_MAX);
  });
  return Promise.race([promisiune, termen]).finally(() => clearTimeout(ceas));
}

// Pana pe 19 septembrie 2026, ORICE esec al intrarii aparea ca „email sau parola
// incorecta" — inclusiv serverul cazut. In ziua penei Supabase, mesajul a trimis-o
// pe Luminita sa-si schimbe o parola care era buna. Acum se spune ce s-a intamplat.
// `cereParola` e fals la resetare, unde „parola gresita" n-are inteles.
function mesajEroare(error, cereParola) {
  if (error.expirat) return t('auth', 'serverNuRaspunde');
  const cod = error.code || '';
  const stare = typeof error.status === 'number' ? error.status : 0;
  // Reteaua cazuta, serverul mut sau 5xx: supabase-js le da fara stare sau cu 5xx.
  if (!stare || stare >= 500 || error.name === 'AuthRetryableFetchError') return t('auth', 'serverNuRaspunde');
  if (stare === 429 || cod === 'over_request_rate_limit') return t('auth', 'preaMulteIncercari');
  if (cod === 'email_not_confirmed') return t('auth', 'emailNeconfirmat');
  if (cereParola && (cod === 'invalid_credentials' || stare === 400 || stare === 401)) return t('auth', 'emailParolaIncorecta');
  return t('auth', 'eroarePrefix') + (error.message || '');
}

export default function Auth() {
  const [email, setEmail] = useState('');
  const [parola, setParola] = useState('');
  const [loading, setLoading] = useState(false);
  const [eroare, setEroare] = useState('');
  const [resetMode, setResetMode] = useState(false);
  const [resetTrimis, setResetTrimis] = useState(false);

  async function handleLogin(e) {
    e.preventDefault();
    setLoading(true);
    setEroare('');
    const { error } = await cuTermen(supabase.auth.signInWithPassword({ email, password: parola }));
    if (error) setEroare(mesajEroare(error, true));
    setLoading(false);
  }

  async function handleReset(e) {
    e.preventDefault();
    setLoading(true);
    setEroare('');
    const { error } = await cuTermen(supabase.auth.resetPasswordForEmail(email, {
      redirectTo: 'https://nm-social.vercel.app',
    }));
    if (error) setEroare(mesajEroare(error, false));
    else setResetTrimis(true);
    setLoading(false);
  }

  return (
    <div style={{ minHeight: '100vh', background: '#F2F8F4', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'DM Sans', sans-serif" }}>
      <div style={{ background: 'white', borderRadius: 16, padding: '40px 48px', width: 400, border: '1.5px solid #D1E8DA', boxShadow: '0 4px 24px rgba(26,107,60,0.08)' }}>
        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 6, marginBottom: 8, fontSize: 12 }}>
          <button type="button" onClick={() => setLang('ro')} style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontFamily: "'DM Sans', sans-serif", fontSize: 12, color: '#6B8B79', fontWeight: getLang() === 'ro' ? 700 : 400, opacity: getLang() === 'ro' ? 1 : 0.5 }}>RO</button>
          <span style={{ color: '#C7D9CF' }}>|</span>
          <button type="button" onClick={() => setLang('en')} style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontFamily: "'DM Sans', sans-serif", fontSize: 12, color: '#6B8B79', fontWeight: getLang() === 'en' ? 700 : 400, opacity: getLang() === 'en' ? 1 : 0.5 }}>EN</button>
        </div>
        <div style={{ marginBottom: 32, textAlign: 'center' }}>
          <div style={{ width: 44, height: 44, borderRadius: 10, background: '#1A6B3C', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px', fontFamily: "'DM Serif Display', serif", fontSize: 20, color: 'white' }}>N</div>
          <div style={{ fontFamily: "'DM Serif Display', serif", fontSize: 22, color: '#0F3D22', letterSpacing: -0.5 }}>NM Social</div>
          <div style={{ fontSize: 13, color: '#6B7280', marginTop: 4 }}>{t('auth', 'byNewMind')}</div>
        </div>

        {resetTrimis ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 40, marginBottom: 16 }}>📧</div>
            <div style={{ fontSize: 15, fontWeight: 600, color: '#0F3D22', marginBottom: 8 }}>{t('auth', 'emailTrimis')}</div>
            <div style={{ fontSize: 13, color: '#6B7280', marginBottom: 24 }}>{t('auth', 'verificaInbox', { email })}</div>
            <button onClick={() => { setResetMode(false); setResetTrimis(false); }} style={{ background: 'none', border: 'none', color: '#1A6B3C', fontSize: 13, cursor: 'pointer', fontWeight: 500 }}>{t('auth', 'inapoiLogin')}</button>
          </div>
        ) : resetMode ? (
          <form onSubmit={handleReset}>
            <div style={{ marginBottom: 8, fontSize: 14, fontWeight: 600, color: '#0F3D22' }}>{t('auth', 'resetareParola')}</div>
            <div style={{ marginBottom: 20, fontSize: 13, color: '#6B7280' }}>{t('auth', 'introduEmailReset')}</div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#4B5563', letterSpacing: '0.5px', textTransform: 'uppercase', marginBottom: 8 }}>{t('auth', 'email')}</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder={t('auth', 'emailPlaceholder')}
                required
                style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #D1E8DA', borderRadius: 10, fontFamily: "'DM Sans', sans-serif", fontSize: 14, outline: 'none', boxSizing: 'border-box' }}
              />
            </div>
            {eroare && <div style={{ background: '#FEE2E2', color: '#DC2626', borderRadius: 8, padding: '10px 14px', fontSize: 13, marginBottom: 16 }}>{eroare}</div>}
            <button type="submit" disabled={loading} style={{ width: '100%', padding: '11px', background: loading ? '#D1E8DA' : '#1A6B3C', color: loading ? '#9CA3AF' : 'white', border: 'none', borderRadius: 10, fontFamily: "'DM Sans', sans-serif", fontSize: 14, fontWeight: 500, cursor: loading ? 'not-allowed' : 'pointer' }}>
              {loading ? t('auth', 'seTrimite') : t('auth', 'trimiteLinkReset')}
            </button>
            <div style={{ marginTop: 16, textAlign: 'center' }}>
              <button onClick={() => setResetMode(false)} style={{ background: 'none', border: 'none', color: '#1A6B3C', fontSize: 13, cursor: 'pointer', fontWeight: 500 }}>{t('auth', 'inapoiLogin')}</button>
            </div>
          </form>
        ) : (
          <form onSubmit={handleLogin}>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#4B5563', letterSpacing: '0.5px', textTransform: 'uppercase', marginBottom: 8 }}>{t('auth', 'email')}</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder={t('auth', 'emailPlaceholder')}
                required
                style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #D1E8DA', borderRadius: 10, fontFamily: "'DM Sans', sans-serif", fontSize: 14, outline: 'none', boxSizing: 'border-box' }}
              />
            </div>
            <div style={{ marginBottom: 8 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#4B5563', letterSpacing: '0.5px', textTransform: 'uppercase', marginBottom: 8 }}>{t('auth', 'parola')}</label>
              <input
                type="password"
                value={parola}
                onChange={e => setParola(e.target.value)}
                placeholder="••••••••"
                required
                style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #D1E8DA', borderRadius: 10, fontFamily: "'DM Sans', sans-serif", fontSize: 14, outline: 'none', boxSizing: 'border-box' }}
              />
            </div>
            <div style={{ marginBottom: 20, textAlign: 'right' }}>
              <button type="button" onClick={() => setResetMode(true)} style={{ background: 'none', border: 'none', color: '#1A6B3C', fontSize: 12, cursor: 'pointer', fontWeight: 500 }}>{t('auth', 'aiUitatParola')}</button>
            </div>
            {eroare && <div style={{ background: '#FEE2E2', color: '#DC2626', borderRadius: 8, padding: '10px 14px', fontSize: 13, marginBottom: 16 }}>{eroare}</div>}
            <button type="submit" disabled={loading} style={{ width: '100%', padding: '11px', background: loading ? '#D1E8DA' : '#1A6B3C', color: loading ? '#9CA3AF' : 'white', border: 'none', borderRadius: 10, fontFamily: "'DM Sans', sans-serif", fontSize: 14, fontWeight: 500, cursor: loading ? 'not-allowed' : 'pointer' }}>
              {loading ? t('auth', 'seConecteaza') : t('auth', 'intraInCont')}
            </button>
          </form>
        )}

        <div style={{ marginTop: 24, textAlign: 'center', fontSize: 12, color: '#9CA3AF', lineHeight: 1.6 }}>
          {t('auth', 'prinAutentificare')}{' '}
          <a href="/terms" style={{ color: '#1A6B3C', textDecoration: 'none', fontWeight: 500 }}>{t('auth', 'termeniConditii')}</a>
          {t('auth', 'siConector')}
          <a href="/privacy" style={{ color: '#1A6B3C', textDecoration: 'none', fontWeight: 500 }}>{t('auth', 'politicaConfidentialitate')}</a>.
        </div>
      </div>
    </div>
  );
}